import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { EntitySelector } from "./entitySelector";
import { ClusteredLightContainer } from "core/Lights/Clustered/clusteredLightContainer";
/**
 * A primitive component with a ComboBox for selecting from existing scene clustered light containers.
 * @param props ClusteredLightContainerSelectorProps
 * @returns ClusteredLightContainerSelector component
 */
export const ClusteredLightContainerSelector = (props) => {
    ClusteredLightContainerSelector.displayName = "ClusteredLightContainerSelector";
    const { scene, ...rest } = props;
    const getClusteredLightContainers = useCallback(() => scene.lights.filter((light) => light instanceof ClusteredLightContainer), [scene.lights]);
    const getName = useCallback((container) => container.name, []);
    return _jsx(EntitySelector, { ...rest, getEntities: getClusteredLightContainers, getName: getName });
};
//# sourceMappingURL=clusteredLightContainerSelector.js.map